<template>
  <div data-app>
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>
    <v-card>
      <v-card-title>Attack History</v-card-title>
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="history"
        :search="search"
        item-key="id"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:item.peak_pps="{ item }">
          <span
            >{{ (item.peak_pps.value / 1000 / 1000).toFixed(1) }} Mpkt/s</span
          >
        </template>
        <template v-slot:item.peak_bps="{ item }">
          <span
            >{{
              ((item.peak_bps.value * 8) / 1000 / 1000 / 1000).toFixed(1)
            }}
            Gb/s</span
          >
        </template>
        <template v-slot:header.detail="{ header }">
          <span>{{ header.text }}</span>
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-1" color="grey" v-bind="attrs" v-on="on"
                >mdi-information-outline</v-icon
              >
            </template>
            <span>Analysis is powered by AI and may not be fully accurate</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/common/api.service";

export default {
  mounted() {
    let start = new Date();
    start.setMonth(start.getMonth() - 1);
    api
      .query("attack_history", { params: { start: start.toISOString() } })
      .then(
        (response) =>
          (this.history = response.data.attack_history.map((row) => ({
            ...row,
            id: `${row.host}_${row.start}`,
          })))
      )
      .catch((error) => (this.errors = [error]))
      .finally(() => (this.loading = false));
  },

  data: () => ({
    selected: [],
    headers: [
      { text: "Host", value: "host" },
      { text: "Reason", value: "reason" },
      { text: "Start", value: "start" },
      { text: "End", value: "end" },
      { text: "Peak packets", value: "peak_pps" },
      { text: "Peak bytes", value: "peak_bps" },
      { text: "Detail", value: "detail"}
    ],
    history: [],
    errors: [],
    loading: true,
    dialog: false,
    search: "",
  }),

  methods: {
    formatPkts(v) {
      return v;
    },
  },
};
</script>
